// src/components/NavBar.js
import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, updateUser } = useContext(AuthContext);

  const auth = useContext(AuthContext);
  console.log("AuthContext value:", auth);

  
  // Retrieve and safely parse the user from localStorage
  // const storedUser = localStorage.getItem('user');
  // console.log("NavBar - Stored user:", storedUser);
  // let user = null;
  // try {
  //   user = storedUser && storedUser !== 'undefined' ? JSON.parse(storedUser) : null;
  //   console.log("NavBar - Parsed user:", user);
  // } catch (error) {
  //   console.error('Error parsing user from localStorage:', error);
  //   user = null;
  // }

  const handleLogout = () => {
    localStorage.removeItem('token');
    updateUser(null);
    navigate('/login');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="bg-white shadow">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Brand */}
          <div className="flex items-center space-x-4">
            <Link to="/" className="text-blue-500 font-bold text-xl">
              MakeMyDogViral
            </Link>
          </div>
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-gray-700 hover:text-blue-500">
              Feed
            </Link>
            <Link to="/submit" className="text-gray-700 hover:text-blue-500">
              Submit Dog
            </Link>
            {user ? (
              <>
                <Link to="/profile" className="text-gray-700 hover:text-blue-500">
                  Profile
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-gray-700 hover:text-blue-500 focus:outline-none"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-gray-700 hover:text-blue-500">
                  Login
                </Link>
                <Link to="/register" className="text-gray-700 hover:text-blue-500">
                  Register
                </Link>
              </>
            )}
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-gray-700 hover:text-blue-500 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-2">
              <Link to="/" className="block text-gray-700 hover:text-blue-500" onClick={() => setIsMobileMenuOpen(false)}>
                Feed
              </Link>
              <Link to="/submit" className="block text-gray-700 hover:text-blue-500" onClick={() => setIsMobileMenuOpen(false)}>
                Submit Dog
              </Link>
              {user ? (
                <>
                  <Link to="/profile" className="block text-gray-700 hover:text-blue-500" onClick={() => setIsMobileMenuOpen(false)}>
                    Profile
                  </Link>
                  <button
                    onClick={() => {
                      handleLogout();
                      setIsMobileMenuOpen(false);
                    }}
                    className="block text-gray-700 hover:text-blue-500 text-left focus:outline-none"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="block text-gray-700 hover:text-blue-500" onClick={() => setIsMobileMenuOpen(false)}>
                    Login
                  </Link>
                  <Link to="/register" className="block text-gray-700 hover:text-blue-500" onClick={() => setIsMobileMenuOpen(false)}>
                    Register
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
